import React from 'react';
import AboutPage from './AboutPage';
import ContactsPage from './ContactsPage';
import ProjectsPage from './ProjectsPage';
import ServicesPage from './ServicesPage';
import MainLogo from '../images/z1.png';
import LanderMain from '../images/lander1.jpeg';
import Roof from '../images/roof1.jpeg';
import Interior from '../images/interior1.jpeg';
function HomePage() {
    return (
        <>
        <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
            
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img className="spec" style={{ marginTop: "50px"}} src={LanderMain} alt="First slide " />
                </div>
                <div className="carousel-item">
                    <img className="spec" style={{ marginTop: "50px"}} src={Roof} alt="Second slide" />
                </div>
                <div className="carousel-item">
                    <img className="spec"  style={{ marginTop: "70px"}} src={Interior} alt="Third slide" />
                </div>
            </div>
            <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="sr-only">Next</span>
            </a>
            </div>
            
            <div className="main-text">
            
                <div className="col-md-12 text-center">
                <img className="spec" src={MainLogo} alt="Main Logo" style={{height : "170px",width : "350px"}}/>
                <h3 className="car-caps" >YOU DREAM IT. WE DESIGN & BUILD IT.</h3>
                </div>
            </div>
            <AboutPage />
            <ServicesPage />
            <ProjectsPage />
            <ContactsPage />
            </>
    );

}

export default HomePage;